import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ClickAction } from '@/data/report'
import useSelect from '@/hooks/use-select'
import { useConfAndQueryStore, useLayoutStore, useProductStore } from '@/store'
import { addThousandSeparator, delay, throttle } from '@/utils'
import { isIOS, win } from '@/utils/device'
import { storeToRefs } from 'pinia'
import { computed, onMounted, onUnmounted, ref } from 'vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductTile',
  props: {
  isLoading: Boolean
},
  setup(__props) {

const props = __props

const layoutStore = useLayoutStore()
const {
  isFilterPanelCollapsed,
  isSnapshotLayerVisible,
  isShownByClosingSnapLayer
} = storeToRefs(layoutStore)
const productStore = useProductStore()
const { hasSelectedProduct } = useSelect()
const { report } = useConfAndQueryStore()

const visibility = computed<
  | 'loading'
  | 'snapshotting'
  | 'closing-snap-layer'
  | 'idle'
  | 'ready'
  | 'visible'
>(() => {
  if (props.isLoading) return 'loading'
  if (isSnapshotLayerVisible.value) return 'snapshotting'
  if (isShownByClosingSnapLayer.value) return 'closing-snap-layer'
  if (!hasSelectedProduct.value) return 'ready'
  if (!isFilterPanelCollapsed.value) return 'idle'
  return 'visible'
})

const productInfo = computed(() => {
  return {
    titleKey: productStore.selectedProduct?.titleString,
    titleFragments: (productStore.selectedProduct?.title || []).map(
      ({
        text,
        isAsciiOrExtended
      }: {
        text: string
        isAsciiOrExtended: boolean
      }) => ({
        text,
        typo: isAsciiOrExtended
          ? 'ABChanelCorpo-2022-Regular font-16'
          : 'PingFangSC-Medium font-14'
      })
    ),
    priceString: `¥${addThousandSeparator(
      productStore.selectedProduct?.price || 0
    )}`
  }
})

const isJumping = ref(false)
const gotoPdp = throttle(() => {
  if (isJumping.value) return
  if (productStore.selectedProduct?.skuId) {
    console.log(
      '[[ Weixin ] Goto PDP ]',
      productStore.selectedProduct.skuId,
      Date.now()
    )
    isJumping.value = true
    report(ClickAction.JUMP_TO_PRODUCT, productStore.selectedProduct.skuId)
    win.wx?.miniProgram?.navigateTo({
      url: `/pages/pdp-new/index?pdp=${productStore.selectedProduct.skuId}&from=vto-hub`,
      success: async () => {
        console.log('[[ Weixin ] Arrived PDP ]', Date.now())
        await delay(2000)
        isJumping.value = false
      }
    })
  }
}, 1000)

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    console.log('[[ Layout ] Return ]', Date.now())
  } else {
    console.log('[[ Layout ] Gone ]', Date.now())
  }
}

onMounted(() => {
  document.addEventListener('visibilitychange', onVisibilityChange)
})

onUnmounted(() => {
  document.removeEventListener('visibilitychange', onVisibilityChange)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['product-tryon-header', visibility.value, _unref(isIOS) ? 'is-ios' : undefined])
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "product-tryon-tip PingFangSC-Light lh-20 font-12" }, " 探索更多作品详情，敬请前往店铺。 ", -1)
    ]), 2),
    _createElementVNode("div", {
      class: _normalizeClass(['product-tile', visibility.value])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['product-tile-content', visibility.value])
      }, [
        _createVNode(_Transition, {
          name: "info-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: productInfo.value.titleKey,
              class: "product-title lh-18"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productInfo.value.titleFragments, (fragment, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: _normalizeClass(fragment.typo)
                }, _toDisplayString(fragment.text), 3))
              }), 128))
            ]))
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "info-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: productInfo.value.priceString,
              class: "product-price ABChanelCorpo-2022-Regular lh-14 font-12"
            }, _toDisplayString(productInfo.value.priceString), 1))
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "product-link PingFangSC-Regular font-14",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(gotoPdp) && _unref(gotoPdp)(...args)))
        }, " 了解更多 ")
      ], 2)
    ], 2)
  ], 64))
}
}

})